/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_TitleInputs */

const en_shopping_range_title = /** @type {(inputs: Shopping_Range_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date range`)
};

const de_shopping_range_title = /** @type {(inputs: Shopping_Range_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Date range" |
*
* @param {Shopping_Range_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_title = /** @type {((inputs?: Shopping_Range_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_title(inputs)
	return en_shopping_range_title(inputs)
});